<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <div class="phone-field-with-whatsapp">
        <div class="phone-field-input-wrap">
          <vue-tel-input
            v-model="fieldValue"
            :input-id="field.attribute"
            :class="[errorClasses, 'phone-tel-input']"
            :placeholder="inputPlaceholder"
            :disabled="isDisabled"
            :preferred-countries="[
              'be',
              'nl',
              'fr',
              'gb',
              'ie',
              'us',
              'de',
              'es',
              'it',
            ]"
            :input-options="{ showDialCode: true }"
            :valid-characters-only="true"
            input-classes="form-control"
          />
        </div>
        <a
          v-if="field.whatsUpBtn"
          :href="hasValidWhatsAppPhone ? whatsAppUrl : '#'"
          :target="hasValidWhatsAppPhone ? '_blank' : null"
          :rel="hasValidWhatsAppPhone ? 'noopener noreferrer' : null"
          class="whatsapp-btn"
          :class="{ 'whatsapp-btn--active': hasValidWhatsAppPhone }"
          :aria-disabled="!hasValidWhatsAppPhone"
          @click="!hasValidWhatsAppPhone && $event.preventDefault()"
        >
          <i class="svg-whatsapp"></i>
        </a>
      </div>
    </template>
  </component>
</template>

<script>
import { FormTextField } from 'stylemix-base'
import { VueTelInput } from 'vue-tel-input'

export default {
  name: 'PhoneField',

  components: { VueTelInput },

  extends: FormTextField,

  computed: {
    cleanPhone() {
      return (this.fieldValue || '').replace(/[^\d]/g, '')
    },
    hasValidWhatsAppPhone() {
      return this.cleanPhone.length >= 10
    },
    whatsAppUrl() {
      return `https://api.whatsapp.com/send/?phone=${this.cleanPhone}`
    },
  },

}
</script>

<style scoped lang="scss">
.phone-field-with-whatsapp {
  display: flex;
  align-items: center;
  gap: 10px;
}

.phone-field-input-wrap {
  flex: 1;
  min-width: 0;
}

.whatsapp-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;

  background-color: #fff;
  border: 1px solid #dee2e6;
  color: #495057;

  &:hover:not([aria-disabled='true']) {
    background-color: #dcf8dc;
    border-color: #25d366;
    color: #25d366;
  }

  &[aria-disabled='true'] {
    cursor: default;
    pointer-events: none;
  }
}
</style>
